import { atom } from "recoil";

export const userAtom = atom<{ phone?: string; uid?: string }>({
  key: "user",
  default: JSON.parse(localStorage.getItem("user")) || {},
});
